import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, contentTypes, compressionType } = formData;
  const availableContent = [
    { label: "JSON Array", value: "JSON_ARRAY" },
    { label: "Comma Separated Values (CSV)", value: "COMMA_SEPARATED_VALUES" },
    { label: "GELF (Newline Delimited)", value: "GELF" },
    { label: "Text (Newline Delimited)", value: "TEXT_PLAIN" }
  ];
  const availableCompressionType = [
    { label: "GZIP", value: "GZIP" },
    { label: "None", value: "NONE" }
  ];
  const [contentTypeVal] = useState(false);
  const [compressionTypeVal] = useState(false);
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minutes."
      });
    }
  };
  const handleSqsMessageBatchSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Proceed",
      title: "",
      error: formError,
      disabled: !!formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Content Type"),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        name: "content_type",
        id: "contentTypes",
        onChange: (selected) => onChange({ target: { name: "contentTypes", value: selected } }),
        options: availableContent,
        value: (contentTypes == null ? void 0 : contentTypes.value) || ""
      }
    ),
    contentTypeVal && (!(contentTypes == null ? void 0 : contentTypes.value) || contentTypes.value.length === 0) && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, "Select at least one"),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The content type of your log files."),
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Compression Type"),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        name: "compression_type",
        id: "compressionType",
        onChange: (selected) => onChange({ target: { name: "compressionType", value: selected } }),
        options: availableCompressionType,
        value: (compressionType == null ? void 0 : compressionType.value) || ""
      }
    ),
    compressionTypeVal && (!(compressionType == null ? void 0 : compressionType.value) || compressionType.value.length === 0) && /* @__PURE__ */ React.createElement("label", { htmlFor: "compressionType" }, "Select at least one"),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The format of the log files."),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: "Determines how often (in minutes) new logs from S3 will be checked. The smallest allowable interval is 1 minute.",
        label: "Polling Interval"
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleSqsMessageBatchSizeChange })
  );
};
export default StepSubscribe;
